"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65],{

/***/ 6624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AdBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32223);



function AdBanner(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        py: 4,
        m: "auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            maxWidth: 728,
            children: children
        })
    });
};


/***/ }),

/***/ 42492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BannerContent_BannerContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/GenericBanner/index.ts + 1 modules
var GenericBanner = __webpack_require__(5750);
;// CONCATENATED MODULE: ./src/components/BannerContent/BannerContent.tsx



var BannerContent = function(param) {
    var banners = param.banners, headingFontColor = param.headingFontColor, smallHeadingFontColor = param.smallHeadingFontColor;
    return banners ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: banners.map(function(banner, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericBanner/* default */.Z, {
                content: banner,
                headingFontColor: headingFontColor || 'text.base',
                smallHeadingFontColor: smallHeadingFontColor || 'text.light'
            }, index);
        })
    }) : null;
};
/* harmony default export */ var BannerContent_BannerContent = (BannerContent);

;// CONCATENATED MODULE: ./src/components/BannerContent/index.ts



/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExpressDealModal; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77584);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


function useExpressDealModal() {
    var qsKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'modal', qsValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'express-deals';
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var query = router.query, pathname = router.pathname;
    var isOpen = query[qsKey] === qsValue;
    var openModal = function() {
        router.push({
            pathname: pathname,
            query: _objectSpread({}, query, _defineProperty({}, qsKey, qsValue))
        }, undefined, {
            shallow: true
        });
    };
    var closeModal = function() {
        router.push({
            pathname: pathname,
            query: (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
                qsKey
            ], query)
        }, undefined, {
            shallow: true
        });
    };
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: closeModal
    };
};


/***/ }),

/***/ 84668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ExpressDealModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92591);
/* harmony import */ var pcln_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73415);
/* harmony import */ var _components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5527);
/* harmony import */ var _hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23385);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92265);
/* harmony import */ var _constants_content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66466);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80730);
/* harmony import */ var _SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50309);
/* harmony import */ var _SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81743);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











function ExpressDealModal(param) {
    var isModalOpen = param.isModalOpen, _gaCategory = param.gaCategory, gaCategory = _gaCategory === void 0 ? _constants_analytics__WEBPACK_IMPORTED_MODULE_4__/* .ANALYTICS_CATEGORY_HOTELS */ .T : _gaCategory, _qsKey = param.qsKey, qsKey = _qsKey === void 0 ? 'modal' : _qsKey, _qsValue = param.qsValue, qsValue = _qsValue === void 0 ? 'express-deals' : _qsValue;
    var closeModal = (0,_hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(qsKey, qsValue).closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        enableOverflow: true,
        ariaLabel: "Express Deals Search Modal",
        isOpen: isModalOpen,
        onClose: closeModal,
        timeout: 50,
        width: [
            1,
            750
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            p: [
                3,
                0
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    px: [
                        0,
                        3
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            fontSize: [
                                3,
                                null,
                                null,
                                5
                            ],
                            lineHeight: "display",
                            tag: "h1",
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.hotel.expressDeals.headline */ .ZP.homepage.hotel.expressDeals.headline
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            fontSize: [
                                1,
                                null,
                                null,
                                4
                            ],
                            mb: 3,
                            lineHeight: "display",
                            tag: "h2",
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.hotel.expressDeals.subHeadline */ .ZP.homepage.hotel.expressDeals.subHeadline
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    pb: 4,
                    px: [
                        0,
                        3
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        onSubmit: function(values) {
                            return (0,_SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__/* .handleSubmitForExpressDeals */ .C5)(_objectSpread({}, values, {
                                gaCategory: gaCategory
                            }));
                        },
                        promoDeal: _constants__WEBPACK_IMPORTED_MODULE_6__/* .PromoDeal.EXPRESS_DEAL */ .cS.EXPRESS_DEAL
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 81263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RotatingBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92833);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77072);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92591);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  0% { opacity: 0; }\n  50% { opacity: 1; }\n  51% { opacity: 0; }\n  100% { opacity: 0; }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 8s infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 8s 4s infinite;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: transparent;\n  background-size: contain;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var rotateText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject());
var FlexWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5a895b37-0"
})(_templateObject1());
var PrimaryBanner = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-5a895b37-1"
})(_templateObject2(), rotateText);
var SecondaryBanner = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5a895b37-2"
})(_templateObject3(), rotateText);
var StyledBackgroundImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5a895b37-3"
})(_templateObject4());
function RotatingBanner(_param) {
    var image = _param.image, primaryBannerText = _param.primaryBannerText, secondaryBannerText = _param.secondaryBannerText, props = _objectWithoutProperties(_param, [
        "image",
        "primaryBannerText",
        "secondaryBannerText"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FlexWrapper, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PrimaryBanner, {
                color: "primary",
                fontWeight: "normal",
                children: [
                    primaryBannerText,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SecondaryBanner, {
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        color: "primary",
                        fontWeight: "normal",
                        children: secondaryBannerText
                    }),
                    image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        mx: 3,
                        width: "310px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBackgroundImage, _objectSpread({
                            image: "".concat(image, "?opto&auto=webp")
                        }, props))
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 8419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ WhyPricelineBanner_WhyPricelineBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/BlockLink/BlockLink.js
var BlockLink = __webpack_require__(21477);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Cars.js
var Cars = __webpack_require__(70895);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Discount.js
var Discount = __webpack_require__(72027);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Email.js
var Email = __webpack_require__(40124);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Help.js
var Help = __webpack_require__(45932);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Phone.js
var Phone = __webpack_require__(11761);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Verified.js
var Verified = __webpack_require__(26310);
;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/ReasonsToBelieveTile.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-b1bde579-0"
})(_templateObject());
var ConditionalBlockLink = function(param) {
    var children = param.children, href = param.href;
    return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLink/* default */.Z, {
        href: href,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var ICONS = {
    Cars: Cars/* default */.Z,
    Discount: Discount/* default */.Z,
    Email: Email/* default */.Z,
    Help: Help/* default */.Z,
    Phone: Phone/* default */.Z,
    Verified: Verified/* default */.Z
};
var ReasonsToBelieveTile = function(param) {
    var headingFontColor = param.headingFontColor, _href = param.href, href = _href === void 0 ? '' : _href, iconColor = param.iconColor, subtextFontColor = param.subtextFontColor, tileContent = param.tileContent, tileCount = param.tileCount;
    var heading = tileContent.heading, iconName = tileContent.iconName, subtext = tileContent.subtext;
    var Icon = ICONS[iconName] || Box/* default */.Z;
    var paddingX = tileCount < 4 ? 4 : 2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
        width: 1 / tileCount,
        px: paddingX,
        py: 3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalBlockLink, {
            href: href,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    color: iconColor,
                    size: 28
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    caps: true,
                    color: headingFontColor,
                    textAlign: "center",
                    textStyle: "heading5",
                    py: 2,
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    color: subtextFontColor,
                    textAlign: "center",
                    textStyle: "paragraph",
                    children: subtext
                })
            ]
        })
    });
};
/* harmony default export */ var WhyPricelineBanner_ReasonsToBelieveTile = (ReasonsToBelieveTile);

;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/WhyPricelineBanner.tsx
function WhyPricelineBanner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function WhyPricelineBanner_templateObject() {
    var data = WhyPricelineBanner_taggedTemplateLiteral([
        "\n  max-width: 1280px;\n"
    ]);
    WhyPricelineBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7e5f1de1-0"
})(WhyPricelineBanner_templateObject());
var WhyPricelineBanner = function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? 'background.lightest' : _backgroundColor, content = param.content, _headingFontColor = param.headingFontColor, headingFontColor = _headingFontColor === void 0 ? 'text.base' : _headingFontColor, _iconColor = param.iconColor, iconColor = _iconColor === void 0 ? 'primary' : _iconColor, _subtextFontColor = param.subtextFontColor, subtextFontColor = _subtextFontColor === void 0 ? 'text.light' : _subtextFontColor;
    var tileCount = content.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        color: backgroundColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
            color: backgroundColor,
            justifyContent: "space-around",
            mx: "auto",
            p: 3,
            tileCount: tileCount,
            children: content && content.map(function(tileContent) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyPricelineBanner_ReasonsToBelieveTile, {
                    href: tileContent.href,
                    headingFontColor: headingFontColor,
                    iconColor: iconColor,
                    subtextFontColor: subtextFontColor,
                    tileContent: tileContent,
                    tileCount: tileCount
                }, tileContent.iconName);
            })
        })
    });
};
/* harmony default export */ var WhyPricelineBanner_WhyPricelineBanner = (WhyPricelineBanner);

;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/index.ts



/***/ }),

/***/ 7905:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    gaAction: 'Theme Park',
    smallHeadingText: "A VACATION YOU'LL REMEMBER FOREVER",
    headingText: 'Walt Disney World Vacations',
    contentText: 'Book your Walt Disney World tickets here! Plus, complete your vacation and book your hotel.',
    alt: 'Walt Disney World',
    image: 'https://s1.pclncdn.com/pcln/promotions/disney-universal-2020/StarWarsGalaxyEdge.jpg?opto=true&auto=webp',
    buttons: [
        {
            gaLabel: 'Walt Disney World',
            buttonText: 'More Info',
            linkUrl: '/partner/hotels/walt-disney-world-v1.html'
        }
    ]
});


/***/ }),

/***/ 1687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YT": function() { return /* binding */ REASONS_HOME; },
/* harmony export */   "vw": function() { return /* binding */ REASONS_HOTELS_LP_DEFAULT; },
/* harmony export */   "Yz": function() { return /* binding */ REASONS_HOTELS_LP_VARIANT; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FLEXIBLE_BOOKING_TILE = {
    iconName: 'Verified',
    heading: 'Flexible Bookings',
    subtext: 'Plans change. That’s why we offer free cancellation on most hotels & rental cars.'
};
var DISCOUNT_TILE = {
    iconName: 'Discount',
    heading: 'Incredible Deals',
    subtext: 'Check out with confidence. Priceline members always get our best price.',
    href: '/static-pages/best-price-guarantee.html'
};
var DISCOUNT_HOTELS_LP_TILE = {
    iconName: 'Discount',
    heading: 'Book With Confidence',
    subtext: 'Priceline members always get our best price.',
    href: '/static-pages/best-price-guarantee.html'
};
var RC_TILE = {
    iconName: 'Cars',
    heading: 'No Flight? No Problem',
    subtext: 'Bundle hotel & rental car deals to build your perfect getaway. No airtime required.'
};
var PHONE_HOTELS_LP_VARIANT_TILE = {
    iconName: 'Phone',
    heading: 'Unlock Special Discounts',
    subtext: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "1 in 4 people save 20% or more over the phone. Call Now.",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
            "(833) 378-0470"
        ]
    })
};
var HELP_TILE = {
    iconName: 'Help',
    heading: 'Help 24/7',
    subtext: 'We’re always here for you – reach us 24 hours a day, 7 days a week.',
    href: 'https://help.priceline.com'
};
var REASONS_HOME = [
    FLEXIBLE_BOOKING_TILE,
    DISCOUNT_TILE,
    RC_TILE,
    HELP_TILE
];
var REASONS_HOTELS_LP_DEFAULT = [
    FLEXIBLE_BOOKING_TILE,
    DISCOUNT_HOTELS_LP_TILE,
    RC_TILE,
    HELP_TILE
];
var REASONS_HOTELS_LP_VARIANT = [
    FLEXIBLE_BOOKING_TILE,
    DISCOUNT_HOTELS_LP_TILE,
    PHONE_HOTELS_LP_VARIANT_TILE,
    HELP_TILE
];


/***/ })

}]);